// extracted by mini-css-extract-plugin
export default {"Position":"B6IkL","skeleton-progress":"_0Dxua"};